import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { config } from "../_helpers/global";

export class AddProcedureCost extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      procedurename: "",
      procedurecost: "",
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
    };
    event.preventDefault();
    console.log(this.state);
    this.setState({ loading: true });

    axios
      .post(this.api_url+"chief/procedurecosts", this.state, {
        headers: headers,
      })
      .then((response) => {
        this.setState({ loading: false });
        if (response.data["success"]) {
          $("#procedureSuccess").show();
          setTimeout(function (props) {
            window.location.reload();
          }, 1000);
        } else {
          $("#procedureError").show();
        }
      })
      .catch((error) => {
        $("#procedureError").show();
        this.setState({ loading: false });
        console.log(error);
      });
  };

  componentDidMount() {
    //     const article = { title: 'React POST Request Example' };
    // axios.post('https://reqres.in/api/articles', article)
    // .then(response => this.setState({ articleId: response.data.id }));
  }

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const { procedurename, procedurecost } = this.state;
    const loading = this.state.loading;
    return (
      <div>
        <Headers />
        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Details
                  </p>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Procedure Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={procedurename}
                      name="procedurename"
                      type="text"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Procedure Cost
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={procedurecost}
                      name="procedurecost"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="procedureError"
                style={displayHidden}
                role="alert"
              >
                <strong>Error </strong>Incorrect data. Check and try again.
              </div>
              <div
                id="procedureSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong> Procedure Cost Added Successfully
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {" "}
                    {loading ? <span>Loading...</span> : <span>Submit</span>}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default AddProcedureCost;
